module.exports = __webpack_public_path__ + "static/media/2v.032679d6.jpg";